export default __webpack_public_path__ + "static/media/integrationsEmptyState.e2b3cd35.svg";